module.exports = __webpack_public_path__ + "static/media/Illus-Outpost_1@3x.a4f720d9.png";